<template>
  <div>
    <Head></Head>
    <Navbar />
    <Banner></Banner>
    <div class="container">
      <div class="content">
        <div class="title">{{ title }}</div>
        <div class="videoPlay">
          <video
            width="100%"
            height="100%"
            controls
            autoplay
          >
            <source
              :src="videoUrl"
              type="video/mp4"
            />
          </video>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Head from './index/Head';
import Navbar from './index/Navbar.vue';
import Banner from './index/Banner';
import Footer from './index/Footer';

export default {
  name: 'Contact',
  components: {
    Head,
    Navbar,
    Banner,
    Footer,
  },
  props: {
    videoId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      title: '',
      videoUrl: '',

      videos: new Map([
        [
          '1',
          {
            title: '春节期间，老人的健康问题',
            videoUrl: 'https://ylts.oss-cn-hangzhou.aliyuncs.com/video/offical/1.%E6%80%BB.mp4',
          },
        ],
        [
          '2',
          {
            title: '老人健康过大年要“六防”——防操劳过累',
            videoUrl:
              'https://ylts.oss-cn-hangzhou.aliyuncs.com/video/offical/2.%E4%B8%80%E9%98%B2.mp4',
          },
        ],
        [
          '3',
          {
            title: '老人健康过大年要“六防”——防烟酒过量',
            videoUrl:
              'https://ylts.oss-cn-hangzhou.aliyuncs.com/video/offical/3.%E4%BA%8C%E9%98%B2.mp4',
          },
        ],
        [
          '4',
          {
            title: '老人健康过大年要“六防”——防饮食过饱',
            videoUrl:
              'https://ylts.oss-cn-hangzhou.aliyuncs.com/video/offical/4.%E4%B8%89%E9%98%B2.mp4',
          },
        ],
        [
          '936',
          {
            title: '二十四节气里的中医养生智慧 大寒',
            videoUrl:
              'https://ylts.oss-cn-hangzhou.aliyuncs.com/video/a45685c60d8956083970ece2e4f448c7.mp4',
          },
        ],
        [
          '412',
          {
            title: '关公提刀上灞桥',
            videoUrl:
              'https://ylts.oss-cn-hangzhou.aliyuncs.com/video/8c7ed19b83d7e0cd026fac6662d9a9a2.mp4',
          },
        ],
        [
          '406',
          {
            title: '庐州太极精编三十六式',
            videoUrl:
              'https://ylts.oss-cn-hangzhou.aliyuncs.com/video/4bd0162ca57bb62b6937955ff44b2e0f.mp4',
          },
        ],
        [
          '264',
          {
            title: '白肉PK红肉',
            videoUrl:
              'https://ylts.oss-cn-hangzhou.aliyuncs.com/video/0e6e678b3ff1e5df51afb617c683d7a3.mp4',
          },
        ],
      ]),
    };
  },
  computed: {},
  watch: {},
  created() {
    // console.log("created " + this.videoId);
  },
  mounted() {
    // console.log("mounted " + this.videoId);
    // this.setTitle();


    this.title = this.videos.get(this.videoId).title;
    this.videoUrl = this.videos.get(this.videoId).videoUrl;
  },
  methods: {
    setTitle() {
      if (this.videoId == 936) {
        this.title = '二十四节气里的中医养生智慧 大寒';
        this.videoUrl =
          'https://ylts.oss-cn-hangzhou.aliyuncs.com/video/a45685c60d8956083970ece2e4f448c7.mp4';
      } else if (this.videoId == 412) {
        this.title = '关公提刀上灞桥';
        this.videoUrl =
          'https://ylts.oss-cn-hangzhou.aliyuncs.com/video/8c7ed19b83d7e0cd026fac6662d9a9a2.mp4';
      } else if (this.videoId == 406) {
        this.title = '庐州太极精编三十六式';
        this.videoUrl =
          'https://ylts.oss-cn-hangzhou.aliyuncs.com/video/4bd0162ca57bb62b6937955ff44b2e0f.mp4';
      } else {
        this.title = '白肉PK红肉';
        this.videoUrl =
          'https://ylts.oss-cn-hangzhou.aliyuncs.com/video/0e6e678b3ff1e5df51afb617c683d7a3.mp4';
      }
    },
  },
};
</script>

<style scoped lang="less">
.container {
  width: 100%;
  background-color: white;
  overflow: hidden;
}

.content {
  width: 1200px;
  // background-color: pink;
  margin: 0 auto;
  overflow: hidden;

  .title {
    font-size: 24px;
    color: #333333;
    font-weight: bold;
    text-align: center;
    // background-color: red;
    margin-top: 50px;
    overflow: hidden;
  }

  .videoPlay {
    width: 800px;
    height: 450px;
    margin: 0 auto;
    margin-top: 50px;
    // background-color: red;
    margin-bottom: 100px;
    text-align: center;
  }
}
</style>
